"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TodaysDateSignature = void 0;
var React = __importStar(require("react"));
var moment_1 = __importDefault(require("moment"));
var __1 = require("../");
var styles = __importStar(require("./TodaysDateSignature.module.css"));
var react_1 = require("react");
var TodaysDateSignature = (function (_super) {
    __extends(TodaysDateSignature, _super);
    function TodaysDateSignature() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TodaysDateSignature.prototype.render = function () {
        if (this.props.signature) {
            if (!this.props.json_data[this.props.id]) {
                this.props.json_data[this.props.id] = (0, moment_1.default)(new Date())
                    .local()
                    .format("MM/DD/YYYY");
                this.props.onChange(this.props.id, this.props.json_data[this.props.id]);
            }
        }
        if (this.props.json_data[this.props.id]) {
            var isUtc = (0, moment_1.default)(this.props.json_data[this.props.id], "YYYY-MM-DDTHH:mm:ss[Z]", true).isValid();
            if (isUtc) {
                this.props.json_data[this.props.id] = (0, moment_1.default)(new Date())
                    .local()
                    .format("MM/DD/YYYY");
                this.props.onChange(this.props.id, this.props.json_data[this.props.id]);
            }
        }
        return React.createElement(__1.Input, __assign({ classNameWrap: styles.root }, this.props));
    };
    return TodaysDateSignature;
}(react_1.Component));
exports.TodaysDateSignature = TodaysDateSignature;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVG9kYXlzRGF0ZVNpZ25hdHVyZS5qcyIsInNvdXJjZVJvb3QiOiIuLyIsInNvdXJjZXMiOlsicGRmL2NvbXBvbmVudHMvVG9kYXlzRGF0ZVNpZ25hdHVyZS9Ub2RheXNEYXRlU2lnbmF0dXJlLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsMkNBQThCO0FBQzlCLGtEQUEyQjtBQUUzQix5QkFBeUI7QUFDekIsdUVBQTBEO0FBQzFELCtCQUErQjtBQWEvQjtJQUF5Qyx1Q0FBb0I7SUFBN0Q7O0lBMEJBLENBQUM7SUF6Qkcsb0NBQU0sR0FBTjtRQUNJLElBQUksSUFBSSxDQUFDLEtBQUssQ0FBQyxTQUFTLEVBQUU7WUFDdEIsSUFBSSxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsU0FBUyxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsRUFBRSxDQUFDLEVBQUU7Z0JBQ3RDLElBQUksQ0FBQyxLQUFLLENBQUMsU0FBUyxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsRUFBRSxDQUFDLEdBQUcsSUFBQSxnQkFBTSxFQUFDLElBQUksSUFBSSxFQUFFLENBQUM7cUJBQ25ELEtBQUssRUFBRTtxQkFDUCxNQUFNLENBQUMsWUFBWSxDQUFDLENBQUE7Z0JBQ3pCLElBQUksQ0FBQyxLQUFLLENBQUMsUUFBUSxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsRUFBRSxFQUFFLElBQUksQ0FBQyxLQUFLLENBQUMsU0FBUyxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQTthQUMxRTtTQUNKO1FBQ0QsSUFBSSxJQUFJLENBQUMsS0FBSyxDQUFDLFNBQVMsQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLEVBQUUsQ0FBQyxFQUFFO1lBQ3JDLElBQU0sS0FBSyxHQUFHLElBQUEsZ0JBQU0sRUFDaEIsSUFBSSxDQUFDLEtBQUssQ0FBQyxTQUFTLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxFQUFFLENBQUMsRUFDbkMsd0JBQXdCLEVBQ3hCLElBQUksQ0FDUCxDQUFDLE9BQU8sRUFBRSxDQUFBO1lBQ1gsSUFBSSxLQUFLLEVBQUU7Z0JBQ1AsSUFBSSxDQUFDLEtBQUssQ0FBQyxTQUFTLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxFQUFFLENBQUMsR0FBRyxJQUFBLGdCQUFNLEVBQUMsSUFBSSxJQUFJLEVBQUUsQ0FBQztxQkFDbkQsS0FBSyxFQUFFO3FCQUNQLE1BQU0sQ0FBQyxZQUFZLENBQUMsQ0FBQTtnQkFDekIsSUFBSSxDQUFDLEtBQUssQ0FBQyxRQUFRLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxFQUFFLEVBQUUsSUFBSSxDQUFDLEtBQUssQ0FBQyxTQUFTLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFBO2FBQzFFO1NBQ0o7UUFFRCxPQUFPLG9CQUFDLFNBQUssYUFBQyxhQUFhLEVBQUUsTUFBTSxDQUFDLElBQUksSUFBTSxJQUFJLENBQUMsS0FBSyxFQUFJLENBQUE7SUFDaEUsQ0FBQztJQUNMLDBCQUFDO0FBQUQsQ0FBQyxBQTFCRCxDQUF5QyxpQkFBUyxHQTBCakQ7QUExQlksa0RBQW1CIn0=